import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import DoorDetails from '../../components/door/index'
import ContainerPages from '../ContainerPages'
import { getUrgent, getCreditcardAlert, creditCardAlert } from 'apis/doors'
import TopBanners from 'components/common/TopBanner'
import { Urgent } from 'apis/response_types'
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'

export const creditcardAlertMessages: { [key: string]: string } = {
  expired: 'クレジットカードの有効期限が切れています。お手数ですが [アカウント設定](/account/settings/creditcard) より登録情報の変更をお願いします',
  expiring: 'クレジットカードの有効期限が近づいています。お手数ですが [アカウント設定](/account/settings/creditcard) より登録情報の変更をお願いします',
  failure: '決済の更新に失敗したためプランから自動退会しました。[アカウント設定](/account/settings/creditcard) よりクレジットカード情報を変更し、プランへ再参加をお願いします'
};

export default function Container(props: any) {
  // @ts-ignore
  let { door_id } = useParams()
  const [urgent, setUrgent] = useState<Urgent>()
  const [creditcardAlert, setCreditcardAlert] = useState<creditCardAlert | null>()

  const initUrgent = async () => {
    const urgentRes = await getUrgent('display_salon_top')
    setUrgent(urgentRes.data.urgent)
    const creditRes = await getCreditcardAlert()
    setCreditcardAlert(creditRes.data!.creditcard_alert)
  }

  useEffect(() => {
    initUrgent()
  }, [])

  return (
    <ContainerPages component={DoorDetails} doorID={door_id}>
      {urgent && (
          <div className={`globalAlert ${urgent.urgency}`} id="testests">
            <ReactMarkdown
              children={urgent.body.replace(/\r?\n|\r/g, '')}
              linkTarget="_blank"
            ></ReactMarkdown>
          </div>
        )}
      {/* 支払い周りのアラート */}
      {creditcardAlert && (
        <CreditcardAlertWrap>
          <ReactMarkdown
            children={creditcardAlertMessages[creditcardAlert]}
          />
        </CreditcardAlertWrap>
      )}
      <TopBanners doorId={door_id} />
    </ContainerPages>
  )
}

const CreditcardAlertWrap = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  background: #fffe00 0% 0% no-repeat padding-box;
  color: #000;
  @media screen and (max-width: 640px) {
    padding: 8px 12px;
    font-size: 12px;
  }
  a {
    color: #11B5F5;
  }
`